import React from "react";
import { useAppSelector } from "../../../../store/hooks";
const InvalidBarcodeModal = ({ isOpen, onClose }) => {
  const { isPartsURL, isAccessoriesURL } = useAppSelector((state) => state.domain);
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div
        className="invalid-barcode-modal"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-icon">
          <div className="error-icon">✕</div>
        </div>
        
        <h2 className="modal-title">Invalid Barcode</h2>
        <p className="modal-message">
          No product found for the scanned barcode. Please try again or
          check the code.
        </p>
        <button className={isPartsURL ? "modal-ok-btn-parts" : isAccessoriesURL ? "modal-ok-btn-acc" : "modal-ok-btn"} onClick={onClose}>
          Ok
        </button>
      </div>
    </div>
  );
};

export default InvalidBarcodeModal;
